module.exports = __webpack_public_path__ + "static/img/erm1.670f50d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/erm1.png
// module id = ARBY
// module chunks = 37